import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { SearchFilterAction } from '../searchFilter.action';
import { SearchParam } from '../_helpers/searchParam';

export const changeSearchFilterEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(SearchFilterAction.setSearch),
  mergeMap((payload) => {
    if (payload.length === 0) {
      return [
        RouterAction.removeParam(SearchParam.name),
      ];
    }

    return [
      RouterAction.addParam(SearchParam.nameAndValue(payload)),
    ];
  }),
);
